import { doc, getDoc, updateDoc, serverTimestamp, increment, arrayUnion, arrayRemove } from 'firebase/firestore';
import { db } from '../config';

export async function toggleLike(postId: string, userId: string): Promise<{ liked: boolean }> {
  try {
    const postRef = doc(db, 'posts', postId);
    const postDoc = await getDoc(postRef);
    
    if (!postDoc.exists()) {
      throw new Error('Post not found');
    }

    const post = postDoc.data();
    const likedBy = post.likedBy || [];
    const isLiked = likedBy.includes(userId);

    await updateDoc(postRef, {
      likedBy: isLiked ? arrayRemove(userId) : arrayUnion(userId),
      'stats.likes': increment(isLiked ? -1 : 1),
      updatedAt: serverTimestamp()
    });

    return { liked: !isLiked };
  } catch (error: any) {
    throw new Error(error.message || 'Failed to toggle like');
  }
}

export async function checkIfLiked(postId: string, userId: string): Promise<boolean> {
  try {
    const postRef = doc(db, 'posts', postId);
    const postDoc = await getDoc(postRef);
    
    if (!postDoc.exists()) {
      return false;
    }

    const post = postDoc.data();
    return (post.likedBy || []).includes(userId);
  } catch (error) {
    console.error('Error checking like status:', error);
    return false;
  }
}